// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 埋点事件上报 POST /track/event/report */
export async function trackEventReportUsingPOST(
  body: API.maidishijianshangbaoqingqiu[],
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/track/event/report', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
